import "../App.scss";

const Navbar = () => {
  return (
    <div className="navbar">
      <h1>Chooeicha</h1>
    </div>
  );
};

export default Navbar;
